const searchObserver = new MutationObserver(function(mutationList, observer) {
    setTimeout(function() {
        if (BSS_B2B && BSS_B2B.cp) {
            BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
        }
    }, 1000);
})

searchObserver.observe(document.querySelector(".thb-quick-search--results"), {
    attributes: true
})
// const dataLanguage = {
//     "en": {
//         "first_name": "First name",
//         "last_name": "Last name",
//         "email": "Email",
//         "password": "Password",
//         "company-field": "Company",
//         "text-field-c29577910f197": "Website URL",
//         "text-field-cc2eab86e6347": "Instagram URL",
//         "header-field-199ac09fc504c": "Delivery address",
//         "address-field": "Street name",
//         "text-field-702725b2a572e": "Street number",
//         "city-field": "City",
//         "text-field-f7329fb0c90a9": "Zip / postal code",
//         "text-field-669a759abe244": "State / province / region",
//         "country-field": "Country",
//         "text-field-2ec5ddb2b749a": "Company email",
//         "header-field-f62b50ba4e994": "Registered company address",
//         "text-field-2dc6fd903bca3": "Street name",
//         "text-field-6117679d306f3": "Street number",
//         "text-field-d403afa6e47ff": "City",
//         "zip-field": "Zip / postal code",
//         "text-field-010928b1373a4": "State / province / region",
//         "select-group-27e1f99bd7cc3": "Country",
//         "vat-validation": "VAT Registration Number",
//         "select-group-c77029b755460": "Year established",
//         "select-group-5be256a0f8995": "How did you hear about Cleverclixx?",
//         "checkbox-group-96ab2ea03fb23": "Other marketplaces you sell on",
//         "text-field-f08bb591c14d2": "Specify other marketplace you are selling on",
//         "select-group-0be005a8d9312": "Language"
//     },
//     "fr": {
//         "first_name": "Prénom",
//         "last_name": "Nom de famille",
//         "email": "Email",
//         "password": "Mot de passe",
//         "company-field": "Société",
//         "text-field-c29577910f197": "URL du site web",
//         "text-field-cc2eab86e6347": "URL Instagram",
//         "header-field-199ac09fc504c": "Adresse de livraison",
//         "address-field": "Nom de rue",
//         "text-field-702725b2a572e": "Numéro de rue",
//         "city-field": "Ville",
//         "text-field-f7329fb0c90a9": "Code postal",
//         "text-field-669a759abe244": "État / province / région",
//         "country-field": "Pays",
//         "text-field-2ec5ddb2b749a": "Email de la société",
//         "header-field-f62b50ba4e994": "Adresse de la société enregistrée",
//         "text-field-2dc6fd903bca3": "Nom de rue",
//         "text-field-6117679d306f3": "Numéro de rue",
//         "text-field-d403afa6e47ff": "Ville",
//         "zip-field": "Code postal",
//         "text-field-010928b1373a4": "État / province / région",
//         "select-group-27e1f99bd7cc3": "Pays",
//         "vat-validation": "Numéro d'enregistrement TVA",
//         "select-group-c77029b755460": "Année de création",
//         "select-group-5be256a0f8995": "Comment avez-vous entendu parler de Cleverclixx ?",
//         "checkbox-group-96ab2ea03fb23": "Autres marchés sur lesquels vous vendez",
//         "text-field-f08bb591c14d2": "Précisez les autres marchés sur lesquels vous vendez",
//         "select-group-0be005a8d9312": "Langue"
//     },
//     "de": {
//         "first_name": "Vorname",
//         "last_name": "Nachname",
//         "email": "Email",
//         "password": "Passwort",
//         "company-field": "Firma",
//         "text-field-c29577910f197": "Website-URL",
//         "text-field-cc2eab86e6347": "Instagram-URL",
//         "header-field-199ac09fc504c": "Lieferadresse",
//         "address-field": "Straßenname",
//         "text-field-702725b2a572e": "Hausnummer",
//         "city-field": "Stadt",
//         "text-field-f7329fb0c90a9": "Postleitzahl",
//         "text-field-669a759abe244": "Bundesland / Provinz / Region",
//         "country-field": "Land",
//         "text-field-2ec5ddb2b749a": "Unternehmens-E-Mail",
//         "header-field-f62b50ba4e994": "Registrierte Unternehmensadresse",
//         "text-field-2dc6fd903bca3": "Straßenname",
//         "text-field-6117679d306f3": "Hausnummer",
//         "text-field-d403afa6e47ff": "Stadt",
//         "zip-field": "Postleitzahl",
//         "text-field-010928b1373a4": "Bundesland / Provinz / Region",
//         "select-group-27e1f99bd7cc3": "Land",
//         "vat-validation": "USt-Identifikationsnummer",
//         "select-group-c77029b755460": "Gründungsjahr",
//         "select-group-5be256a0f8995": "Wie haben Sie von Cleverclixx erfahren?",
//         "checkbox-group-96ab2ea03fb23": "Weitere Marktplätze, auf denen Sie verkaufen",
//         "text-field-f08bb591c14d2": "Geben Sie weitere Marktplätze an, auf denen Sie verkaufen",
//         "select-group-0be005a8d9312": "Sprache"
//     },
//     "nl": {
//         "first_name": "Voornaam",
//         "last_name": "Achternaam",
//         "email": "Email",
//         "password": "Wachtwoord",
//         "company-field": "Bedrijf",
//         "text-field-c29577910f197": "Website-URL",
//         "text-field-cc2eab86e6347": "Instagram-URL",
//         "header-field-199ac09fc504c": "Bezorgadres",
//         "address-field": "Straatnaam",
//         "text-field-702725b2a572e": "Huisnummer",
//         "city-field": "Stad",
//         "text-field-f7329fb0c90a9": "Postcode",
//         "text-field-669a759abe244": "Provincie / regio",
//         "country-field": "Land",
//         "text-field-2ec5ddb2b749a": "Bedrijfse-mail",
//         "header-field-f62b50ba4e994": "Geregistreerd bedrijfsadres",
//         "text-field-2dc6fd903bca3": "Straatnaam",
//         "text-field-6117679d306f3": "Huisnummer",
//         "text-field-d403afa6e47ff": "Stad",
//         "zip-field": "Postcode",
//         "text-field-010928b1373a4": "Provincie / regio",
//         "select-group-27e1f99bd7cc3": "Land",
//         "vat-validation": "BTW-nummer",
//         "select-group-c77029b755460": "Jaar van oprichting",
//         "select-group-5be256a0f8995": "Hoe heeft u gehoord van Cleverclixx?",
//         "checkbox-group-96ab2ea03fb23": "Andere marktplaatsen waar u op verkoopt",
//         "text-field-f08bb591c14d2": "Geef andere marktplaatsen aan waar u op verkoopt",
//         "select-group-0be005a8d9312": "Taal"
//     }
// }
// let language = 'en';
// if(window.location.pathname.includes("/nl/pages/wholesale")) {
//   language = 'nl';
// }else if(window.location.pathname.includes("/fr/pages/wholesale")) {
//   language = 'fr';
// }else if(window.location.pathname.includes("/de/pages/wholesale")) {
//   language = 'de';
// }
// document.addEventListener("BSS_get_form_success", e => {
//     BSS_B2B.rf.form.content_v2.forEach(item => {
//         item.label = dataLanguage[language][item.id]
//     })
// })


if (typeof BSS_B2B != undefined) {
    if (window.location.pathname.includes("/pages/distributor-registration") ||
        window.location.pathname.includes("/pages/wholesale") ||
        window.location.pathname.includes("/pages/registration-distributor") ||
        window.location.pathname.includes("/pages/cleverclixx-reseller-niet-in-eu")
    ) {
        const loop = setInterval(() => {
            const submitBtn = document.querySelector(".bss-b2b-registration-form-title");
            if (submitBtn) {
                clearInterval(loop);
                submitBtn.insertAdjacentHTML(
                    "afterend",
                    `<div class="bss-switch-login-section">
              <h6>Already have an account?</h6> 
              <a href="/account/login" class="text-button">Login</a>
            </div>`
                );
            }
        }, 500);

        setTimeout(() => {
            clearInterval(loop);
        }, 7000)

    }
}



const pageType =
    window.ShopifyAnalytics &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.page &&
    window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
    let counter = 0;
    const interval = setInterval(() => {
        const footerPrice = document.querySelector(".cart-drawer--terms");
        const taxExWrapper = document.querySelector(".bss-b2b-tax-ex-wrapper.bss-config-header");

        if (footerPrice && taxExWrapper) {
            footerPrice.parentNode.insertBefore(taxExWrapper, footerPrice);
            handleTEBox();


            let quickAddDrawer = document.querySelector('.side-panel.cart-drawer')
            if (quickAddDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            handleTEBox();
                        }
                    });
                });
                observer.observe(quickAddDrawer, {
                    childList: true
                });
            }
            clearInterval(interval);
        } else {
            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }
        }
    }, 100);
} else {
    let counter = 0;
    const interval = setInterval(() => {
        const vatInputWrapper = document.querySelector(".bss-b2b-vat-input-wrapper");
        if (vatInputWrapper) {
            handleTEBox();


            let quickAddDrawer = document.querySelector('.thb-cart-form')
            if (quickAddDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                            handleTEBox();
                        }
                    });
                });
                observer.observe(quickAddDrawer, {
                    childList: true
                });
            }

            clearInterval(interval);
        } else {
            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }
        }
    }, 100);
}

function handleTEBox() {
    const translations = BSS_B2B.vatTranslations;
    const headerText = document.querySelector(
        ".bss-b2b-translation-vat-form_header_text"
    );
    if (headerText) {
        headerText.innerText = translations.form_header_text;
    }

    const subtitleText = document.querySelector(
        ".bss-b2b-translation-vat-form_subtitle_text"
    );
    if (subtitleText) {
        subtitleText.innerText = translations.form_subtitle_text;
    }

    const successMessages = [
        document.querySelector(".bss-b2b-translation-vat-form_success_message"),
        document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
        document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
        document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
        document.querySelector(
            ".bss-b2b-translation-vat-form_success_message_us_ein"
        ),
    ];

    successMessages.forEach((msg, index) => {
        if (msg) {
            switch (index) {
                case 0:
                    msg.innerText = translations.form_success_message || "";
                    break;
                case 1:
                    msg.innerText = translations.form_success_message_uk || "";
                    break;
                case 2:
                    msg.innerText = translations.form_success_message_abn || "";
                    break;
                case 3:
                    msg.innerText = translations.form_success_message_gst || "";
                    break;
                case 4:
                    msg.innerText = translations.form_success_message_us_ein || "";
                    break;
            }
        }
    });

    const errorMessages = [
        document.querySelector(".bss-b2b-translation-vat-form_error_message"),
        document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
        document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
        document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
        document.querySelector(
            ".bss-b2b-translation-vat-form_error_message_us_ein"
        ),
        document.querySelector(
            ".bss-b2b-translation-vat-form_validate_country_code_message"
        ),
    ];

    errorMessages.forEach((msg, index) => {
        if (msg) {
            switch (index) {
                case 0:
                    msg.innerText = translations.form_error_message || "";
                    break;
                case 1:
                    msg.innerText = translations.form_error_message_uk || "";
                    break;
                case 2:
                    msg.innerText = translations.form_error_message_abn || "";
                    break;
                case 3:
                    msg.innerText = translations.form_error_message_gst || "";
                    break;
                case 4:
                    msg.innerText = translations.form_error_message_us_ein || "";
                    break;
                case 5:
                    msg.innerText = translations.form_validate_country_code_message || "";
                    break;
            }
        }
    });
}

document.addEventListener('cart:rerendered', () => {
    if (BSS_B2B) {
        BSS_B2B.observer.cartSubject.listenCartCheckout();
    }
})